module.exports = __webpack_public_path__ + "media/assets/logo/Logo_SemFundo_Agrosim_reduzido_restricted-617427a0141fa99dc3737534ebcf75bf.png";